import styled from "styled-components";
import { Form } from "react-bootstrap";

export const SelectStyled = styled(Form.Control)`
    width: 100%;
    min-height: 120px;
    background-color: #fff;
    border: 1px solid #ced4da;
    padding: 8px;
    color: #212529;
    font-size: 1rem;

    &:disabled {
        background-color: #e9ecef;
    }

    &:focus {
        border-color: #86b7fe;
        box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
    }
`;

export const FeedbackOtherLabel = styled(Form.Text)`
    color: red;
    font-size: 0.875em;
    padding-top: 0.25rem;
    display: block;
`;
export const FormDiv = styled.div`
    margin-bottom: 1rem;
    border: 1px solid #ccc;
    padding: 2% 1rem;
    font-size: 14px;
    border-radius: 5px;
`;
